import Swiper from 'swiper'
import { Mousewheel, FreeMode } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/mousewheel'
import { debounce } from './utils'
;(async function ($) {
	let currentPage = 1
	let searchText = ''
	let nextPosts = ''
	const noPostsInfo = $('.blog-page__empty')
	const postsList = $('.blog-page__posts')
	const seeMoreBtn = $('#see-more-btn')
	const selectedTag = document.querySelector('.blog-page__tag--selected')

	selectedTag?.addEventListener('click', (e) => {
		e.preventDefault()
		const currentPath = location.pathname
		const newPath = currentPath.replace(/\/tag\/[^/]+/, '/blog')
		history.pushState(null, null, newPath)
		location.reload()
	})
	async function getPosts(currentPage, searchText, numberOfPosts = 6) {
		let postsData

		await $.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json',
			data: {
				action: 'get_posts',
				paged: currentPage,
				search: searchText,
				amount: numberOfPosts,
				tagID:
					(location.pathname.includes('/tag/') &&
						location.pathname.substring(location.pathname.indexOf('/tag/') + 5, location.pathname.length - 1)) ||
					''
			},
			success: function (res) {
				postsData = res
			},
			error: function (e) {
				console.error('getPosts error', e)
			}
		})

		return postsData
	}

	function updateBlogLayout(postsData) {
		if (postsData.totalPages <= currentPage) {
			seeMoreBtn.hide()
		} else {
			seeMoreBtn.show()
		}
		if (!postsData.posts) {
			noPostsInfo.addClass('show')
		} else {
			noPostsInfo.removeClass('show')
		}
	}

	if (postsList) {
		const postsData = await getPosts(currentPage, searchText)
		updateBlogLayout(postsData)
		nextPosts = postsData.nextPosts
		postsList.append(postsData.posts)
	}

	seeMoreBtn.on('click', async function () {
		postsList.append(nextPosts)
		currentPage++
		const newPosts = await getPosts(currentPage, searchText)
		nextPosts = newPosts.nextPosts
		updateBlogLayout(newPosts)
	})

	let isGetLatestPosts = true

	async function searchPosts(e) {
		searchText = e.target.value.length >= 3 ? e.target.value : ''
		currentPage = 1
		searchText && (isGetLatestPosts = false)

		if (!isGetLatestPosts) {
			const newPosts = await getPosts(currentPage, searchText)
			postsList.html(newPosts.posts)
			updateBlogLayout(newPosts)
			nextPosts = newPosts.nextPosts
		}

		if (!isGetLatestPosts && !searchText) {
			isGetLatestPosts = true
		}
	}

	const debouncedSearchPosts = debounce(searchPosts, 300)
	$('#search-posts').on('input', (e) => debouncedSearchPosts(e))
})(jQuery)

new Swiper('#latest-posts', {
	spaceBetween: 22,
	slidesPerView: 1,
	mousewheel: {
		releaseOnEdges: true
	},
	freeMode: true,
	modules: [Mousewheel, FreeMode],
	breakpoints: {
		835: {
			slidesPerView: 2
		},
		768: {
			slidesPerView: 1.43
		},
		320: {
			slidesPerView: 1.2
		}
	}
})
